import { useDisclosure } from "@mantine/hooks";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import DeleteReportModal from "src/components/pages/Reports/DeleteReportModal/DeleteReportModal";
import ReportsActionButtons from "src/components/pages/Reports/ReportsActionButtons/ReportsActionButtons";
import BackToYachtButton from "src/components/shared/BackToYachtButton/BackToYachtButton";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import Card from "src/components/shared/Card/Card";
import TileGrid from "src/components/shared/NavigationTile/TileGrid";
import CreateReportButton from "src/components/shared/Reports/CreateReportButton";
import { useGetApi, useIsOnline } from "src/hooks";
import { type IReportItem } from "src/interfaces";
import { useDispatch } from "src/redux/hooks";
import { setYachtName } from "src/redux/slices/generatorSlice";
import { ButtonsWrapper, PageContainer } from "src/styled";

const mapReports = (data: any) => {
  return {
    data: data.data.reports.list as IReportItem[],
    yachtName: data.data.yachtname,
  };
};

const Reports = () => {
  const [opened, { open, close }] = useDisclosure(false);
  const [currentRid, setCurrentRid] = useState("");
  const dispatch = useDispatch();
  const isOnline = useIsOnline();
  const navigate = useNavigate();

  const { data, isLoading, refetch } = useGetApi({
    request: "get-report",
    mapper: mapReports,
  });

  const renderReports = useCallback(() => {
    if (data) {
      dispatch(setYachtName(data.yachtName));
      return data.data.map(report => {
        return (
          <Card
            key={report.rid}
            cardName={report.name}
            cardDetails={report.descr}
            isLoading={isLoading}
            onClick={() => {
              navigate(`/reports/report/${report.rid}`);
            }}>
            {isOnline && (
              <ReportsActionButtons
                reportId={report.rid}
                open={open}
                setCurrentRid={setCurrentRid}
              />
            )}
          </Card>
        );
      });
    }
  }, [data, isLoading, open, dispatch, isOnline, navigate]);

  return (
    <>
      <DeleteReportModal
        opened={opened}
        close={close}
        rid={currentRid}
        refetch={refetch}
      />
      <PageContainer>
        <Breadcrumbs>
          <BackToYachtButton fetchLinks />
          <ButtonsWrapper>
            <CreateReportButton redirectUrl="/reports/add-report" />
          </ButtonsWrapper>
        </Breadcrumbs>

        <TileGrid loading={isLoading}>{renderReports()}</TileGrid>
      </PageContainer>
    </>
  );
};

export default Reports;
